import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, serverTimestamp, collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';

export async function createReport(params = {}) {
  const {
    postId,
    itemType = 'post',
    reasonCategory,
    reasonText = '',
    userId,
    postAuthorId = null,
  } = params;

  if (!postId || !reasonCategory || !userId) {
    throw new Error('Missing required report data');
  }

  const docId = `${itemType}_${postId}_${userId}`;
  const reportRef = doc(db, 'reports', docId);

  const existing = await getDoc(reportRef);
  if (existing.exists()) {
    throw new Error('You have already reported this post');
  }

  const payload = {
    itemType,
    postId,
    userId,
    postAuthorId,
    reasonCategory,
    reasonText,
    status: 'open',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  await setDoc(reportRef, payload);
  return { id: docId };
}

export function subscribeReports({ status = 'all', category = 'all' } = {}, onUpdate, onError) {
  const base = collection(db, 'reports');
  let q = query(base);
  if (status && status !== 'all') {
    q = query(q, where('status', '==', status));
  }
  if (category && category !== 'all') {
    q = query(q, where('reasonCategory', '==', category));
  }
  q = query(q, orderBy('createdAt', 'desc'));
  return onSnapshot(
    q,
    (snap) => {
      const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      if (typeof onUpdate === 'function') onUpdate(rows, snap);
    },
    (err) => {
      if (typeof onError === 'function') onError(err);
    }
  );
}
